/* eslint-disable no-await-in-loop */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */

import diasUteis from '../__mocks__/diasUteis';
import sabados from '../__mocks__/sabados';
import { apiImo as api, apiImoWithoutAuth as apiClient } from './utils/api';

export const postProposal = async (proposalFields) => {
  const res = await api.post('/api/Proposal', proposalFields).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });
  return res;
};

export const postProposalNoConcrete = async (proposalFields) => {
  const res = await api.post('/api/Proposal/NoConcrete', proposalFields).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });
  return res;
};

export const putFunnelBuildingInformations = async ({ proposalId, proposalFields }) => {
  const res = await api.put(`/api/FunnelBuildingInformation/${proposalId}`, proposalFields).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });
  return res;
};

export const postTrait = async (TraitFields) => {
  const res = await api.post('/api/Trait/Simulator', TraitFields).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });
  return res;
};

export const getSemConsumo = async () => {
  const res = await api.get('/api/NonAutoConsumption', { params: { take: 0 } }).then((response) => response.data);
  return res;
};

export const getProposal = async (id, email) => {
  const res = await api.get(`/api/Proposal/${id}/${email}`).then((response) => response.data);
  return res;
};

export const getIsLastProposal = async (proposalId) => {
  const res = await api.get(`/api/Proposal/CheckIsLast/${proposalId}`).then((response) => response.data);
  return res;
};

export const validateClientCode = async ({ token, code }) => {
  const res = await apiClient.post('/api/ClientAccess/ValidateCode', { token, code });
  return res;
};

export const getPropostaClientAccess = async (token) => {
  const res = await apiClient
    .get('/api/ClientAccess/Proposal', { headers: { 'X-Client-Token': token } })
    .then((response) => response.data);
  return res;
};

export const getVendedores = async (email) => {
  const res = await api.get('/api/Seller', { params: { take: 0, office: 1, email } }).then((response) => response.data);

  return res;
};

export const getVendedoresPorCargo = async (cargo) => {
  const res = await api
    .get(`/api/Seller/Role/${cargo}`)
    .then((response) => response.data);

  return res;
};

export const getFabricas = async () => {
  const res = await api.get('/api/Affiliate', { params: { take: 0 } }).then((response) => response.data);
  return res;
};

export const getEficiencias = async () => {
  const res = await api.get('/api/RegionalEfficiency', { params: { take: 0 } }).then((response) => response.data);
  return res;
};

export const getPagamentos = async () => {
  const res = await api.get('/api/Payment', { params: { take: 0 } }).then((response) => response.data);
  return res;
};

export const getHistorico = async (emailSeller) => {
  const res = await api.get('/api/Proposal', { params: { take: 0, email: emailSeller } }).then((response) => response.data);
  return res;
};

export const getAprovacoes = async (emailSeller, params) => {
  const res = await api.get('/api/Proposal/Approval', {
    params: {
      take: params.take,
      skip: params.skip,
      email: emailSeller,
      search: params.search,
      status: params?.status,
      statusNegociacao: params?.statusNegociacao,
      dateInit: params?.dateInit,
      dateEnd: params?.dateEnd,
    },
  }).then((response) => response);
  return res;
};

export const getAprovacoesPendentes = async (emailSeller, params) => {
  const res = await api.get('/api/Proposal/ApprovalPending', {
    params: {
      take: params.take, skip: params.skip, email: emailSeller, search: params.search,
    },
  }).then((response) => response);
  return res;
};

export const getAprovadores = async (id) => {
  const res = await api.get(`/api/Proposal/Approvals/${id}`).then((response) => response.data);
  return res;
};

export const getPaymentbyId = async (id) => {
  const res = await api.get(`/api/Payment/${id}`).then((response) => response.data);
  return res;
};

export const getLastContracts = async (fields) => {
  const res = await api.get(`/api/Contract/Last/${fields.contractCode}`).then((response) => {
    if (response.data) return response.data;
    return response;
  });
  return res;
};

export const getLastProposal = async (fields) => {
  const res = await api.get(`/api/Proposal/Contract/${fields.contractCode}/${fields.email}`).then((response) => {
    if (response.data) return response.data;
    return response;
  });
  return res;
};

export const postAprovar = async (aprovarFields) => {
  const res = await api.post(`/api/Proposal/Approval/${aprovarFields.id}`, aprovarFields).then((response) => response.data);
  return res;
};

export const postAprovarClientAccess = async ({ aprovarFields, token }) => {
  const res = await apiClient
    .post('/api/ClientAccess/Aprovar', aprovarFields, { headers: { 'X-Client-Token': token } })
    .then((response) => response.data);
  return res;
};
export const cancelApproval = async (cancelFields) => {
  const res = await api.post(`/api/Proposal/CancelApproval/${cancelFields.id}`, cancelFields).then((response) => response.data);
  return res;
};

export const sendAprovacao = async (aprovacaoFields) => {
  const res = await api.post(`/api/Proposal/SendApproval/${aprovacaoFields.id}`, aprovacaoFields).then((response) => response);
  return res;
};

export const reSendAprovacao = async (reSendApproval) => {
  const res = await api.post(`/api/Proposal/ReSendApproval/${reSendApproval.id}`, reSendApproval).then((response) => response);
  return res;
};

export const postContract = async (contractFields) => {
  const res = await api.post('/api/Contract', contractFields).then((response) => response?.data || response);
  return res;
};

export const getContract = async (proposalId) => {
  const res = await api.get(`/api/Contract/${proposalId}`).then((response) => response.data);
  return res;
};

export const getContractClientAccess = async (token) => {
  const res = await apiClient
    .get('/api/Contract/ClientAccess', { headers: { 'X-Client-Token': token } })
    .then((response) => response.data);
  return res;
};

export const getParameterContract = async () => {
  const res = await api.get('/api/Contract/Parameters').then((response) => response.data);
  return res;
};

export const getParameterContractClientAccess = async (token) => {
  const res = await apiClient
    .get('/api/Contract/ClientAccess/Parameters', { headers: { 'X-Client-Token': token } })
    .then((response) => response.data);
  return res;
};

export const getParameterEmail = async () => {
  const res = await api.get('/api/Contract/Parameters/Email').then((response) => response.data);
  return res;
};

export const getParameter = async () => {
  const res = await api.get('/api/Parameter').then((response) => response.data);
  return res;
};

export const getCalculoDistancia = async (VolumeTotal, Distancia, Segmento, ContratoSAP) => {
  const res = await api.get('/api/Proposal/Distance', {
    params: {
      Distance: Distancia, ContratoSAP, VolumeTotalTraco: VolumeTotal, Segmento,
    },
  }).then((response) => response.data);
  return res;
};

export const getCalculoDistanciaFabrica = async (distanceFields) => {
  const res = await api.post('/api/Proposal/DistanceCalcule', distanceFields).then((response) => response);
  return res;
};

export const getEspecificacoes = async (AffiliateId, withFamilyDeleted = true) => {
  const res = await api.get(`/api/Trait/Specifications/${AffiliateId}`, { params: { take: 0, familyId: 0, withFamilyDeleted } }).then((response) => response.data);
  return res;
};

export const getEspecificacoesFBS = async () => {
  const res = await api.get('/api/Trait/Specifications').then((response) => response.data);
  return res;
};

export const getTraco = async (traitFamilyId, affiliateId) => api.get(`/api/Trait/Affiliate/${traitFamilyId}/${affiliateId}`).then((response) => response.data);

export const getTracoInclusion = async (traitId, affiliateId, codeContract) => api.get(`/api/AffiliateTrait/Inclusion/${affiliateId}/${traitId}/${codeContract}`).then((response) => response.data);
export const getTracoFabrica = async (traitId, affiliateId, distance) => api.get(`/api/AffiliateTrait/${affiliateId}/${traitId}`, { params: { distance } }).then((response) => response.data);
export const getSpectra = async (spectraStates) => api.post('/api/Spectra/Simulation', spectraStates).then((response) => response.data);

export const getFamilia = async (withDeleted = true) => {
  const res = await api.get('/api/TraitFamily', { params: { take: 0, withDeleted } }).then((response) => response.data);
  return res;
};

export const getMargemContribuicao = async (margemContribuicaoFields) => {
  const res = await api.post('/api/Proposal/ContributionMargin', margemContribuicaoFields).then((response) => response.data);
  return res;
};

export const getAlcada = async (alcadaFields, sellerSchemeId) => {
  const res = await api.post('/api/Proposal/Authorities', { ...alcadaFields, approvalSchemeId: sellerSchemeId }).then((response) => response.data);
  return res;
};

export const getAlcadaInclusao = async (alcadaFields, sellerSchemeId) => {
  const res = await api.post('/api/Proposal/InclusionAuthorities', { ...alcadaFields, approvalSchemeId: sellerSchemeId }).then((response) => response.data);
  return res;
};

export const getRecomendacao = async (recomendacaoFields) => {
  const res = await api.post('/api/Proposal/ContractRecommendations', recomendacaoFields).then((response) => response.data);
  return res;
};

export const getTipoPropostas = async () => {
  const res = await api.get('/api/ProposalType').then((response) => response.data);
  return res;
};

export const getTipoContratos = async () => {
  const res = await api.get('/api/ContractType').then((response) => response.data);
  return res;
};

export const getBomba = async (affiliateId) => api.get(`/api/AffiliateBomb/Bombs/${affiliateId}`).then((response) => response.data);

export const getBombaFilial = async (AffiliateId, bombId) => api.get(`/api/AffiliateBomb/${AffiliateId}/${bombId}`).then((response) => response.data);

export const getSegundaSexta = async () => diasUteis;
export const getSabado = async () => sabados;

export const getPropostaStore = async () => JSON.parse(localStorage.getItem('imoStorage'));

export const downloadPdf = async (pdfHTML) => {
  const res = await api
    .post('/api/Export/PDF', { body: pdfHTML }, { responseType: 'blob' })
    .then((response) => response);

  return res;
};

export const downloadPdfClientAccess = async ({ pdfHTML, token }) => {
  const res = await apiClient
    .post('/api/Export/ClientAccess/PDF', { body: pdfHTML }, { responseType: 'blob', headers: { 'X-Client-Token': token } })
    .then((response) => response);

  return res;
};

export const sendDelegation = async (delegationFields) => {
  const res = await api.post('/api/Delegation', delegationFields).then((response) => response.data);
  return res;
};

export const deleteDelegation = async (id) => {
  const res = await api.delete(`/api/Delegation/${id}`).then((response) => response);
  return res;
};

export const getVendedorEmail = async (email) => {
  const res = await api.get('/api/Seller/Email', { params: { email } }).then((response) => response.data);
  return res;
};

export const getUserTypeByEmail = async (email) => {
  const res = await api.get(`/api/Seller/UserType/${email}`)
    .then((response) => response.data);
  return res;
};

export const sendEmail = async (fields) => {
  const formatedFields = {
    ToEmail: fields.emailTo || '',
    Subject: fields.subject,
    Body: `${fields.body}`,
    Attachment: `${fields.attachment}`,
  };

  let res = { data: null, isSuccess: false };
  if (fields.emails && fields.emails !== undefined && Array.isArray(fields.emails)) {
    for (let i = 0; i < fields.emails.length; i += 1) {
      formatedFields.ToEmail = fields.emails[i];

      res = await api.post(`/api/email/send/${fields.proposalId}`, formatedFields, { headers: { 'Content-Type': 'multipart/form-data' } });
    }
  } else {
    res = await api.post(`/api/email/send/${fields.proposalId}`, formatedFields, { headers: { 'Content-Type': 'multipart/form-data' } });
  }

  return res;
};

export const getProposta = async (codProposta) => {
  // const res = await api.get('/granel/clientes').then((response) => response.data);
  const res = {
    nome: 'DAIANA ILISIA BECKER',
    codProposta: 4479646712961498,
    clienteEmpresa: 'Mitre Realty-Dona Brígida (MTR Reserva Vila Mariana EMP SPE LTDA)',
    codCliente: 1234,
    cliente: 'Felipe Caetano',
    endereco: 'Rua Joaquim Murtinho, 280',
    cidade: 'Santos',
    estado: 'SP',
    email: 'estelapires@gmail.com',
    telefone: '(13) 0000-0000',
    enderecoObra: 'Rua Joaquim Murtinho, 280',
    produtos: [
      {
        codigo: 6162185,
        nome: '6162185 -  ESP C25 B1 SL12± CC>300',
        volume: 56.58,
        preco: 434,
        precoTotal: 23807.73,
      },
      {
        codigo: 6162185,
        nome: '6162185 -  ESP C25 B1 SL12± CC>300',
        volume: 208.52,
        preco: 2100,
        precoTotal: 119955.73,
      },
      {
        codigo: 6162185,
        nome: '6162185 -  ESP C25 B1 SL12± CC>300',
        volume: 56.58,
        preco: 434,
        precoTotal: 23807.73,
      },
      {
        codigo: 6162185,
        nome: '6162185 -  ESP C25 B1 SL12± CC>300',
        volume: 208.52,
        preco: 2100,
        precoTotal: 119955.73,
      },
      {
        codigo: 6162185,
        nome: '6162185 -  ESP C25 B1 SL12± CC>300',
        volume: 56.58,
        preco: 434,
        precoTotal: 23807.73,
      },
      {
        codigo: 6162185,
        nome: '6162185 -  ESP C25 B1 SL12± CC>300',
        volume: 208.52,
        preco: 2100,
        precoTotal: 119955.73,
      },
      {
        codigo: 6162185,
        nome: '6162185 -  ESP C25 B1 SL12± CC>300',
        volume: 56.58,
        preco: 434,
        precoTotal: 23807.73,
      },
      {
        codigo: 6162185,
        nome: '6162185 -  ESP C25 B1 SL12± CC>300',
        volume: 208.52,
        preco: 2100,
        precoTotal: 119955.73,
      },
      {
        codigo: 6162185,
        nome: '6162185 -  ESP C25 B1 SL12± CC>300',
        volume: 56.58,
        preco: 434,
        precoTotal: 23807.73,
      },
      {
        codigo: 6162185,
        nome: '6162185 -  ESP C25 B1 SL12± CC>300',
        volume: 208.52,
        preco: 2100,
        precoTotal: 119955.73,
      },
    ],
    volumeConcreto: 86254.26,
    valorConcreto: 12670,
    volumeBombeado: 86254.26,
    valorBomba: 12670,
    totalProposta: 5964885.5,
  };

  return res;
};

export const postContractApi = async (data) => {
  const res = await api.post('/api/APIContract/', data).then((response) => response);

  return res;
};

export const postContractApiClientAccess = async ({ data, token }) => {
  const res = await apiClient
    .post('/api/APIContract/ClientAccess', data, { headers: { 'X-Client-Token': token } })
    .then((response) => response);

  return res;
};

export const putContractApi = async ({ id, data }) => {
  const res = await api.put(`/api/APIContract/${id}`, data).then((response) => response);

  return res;
};

export const putContractApiClientAccess = async ({ data, token }) => {
  const res = await apiClient
    .put('/api/APIContract/ClientAccess', data, { headers: { 'X-Client-Token': token } })
    .then((response) => response);

  return res;
};

export const putPaymentLinkApi = async ({ id, data }) => {
  const res = await api.put(`/api/APIContract/${id}/Link`, data).then((response) => response);

  return res;
};

export const putPaymentLinkApiClientAccess = async ({ data, token }) => {
  const res = await apiClient
    .put('/api/APIContract/ClientAccess/Link', data, { headers: { 'X-Client-Token': token } })
    .then((response) => response);

  return res;
};

export const downloadPaymentLinkJson = async (linkParameters, filename = 'paymentlink') => {
  const res = await apiClient.post('/api/PaymentLink/Generate', linkParameters).then((response) => response.data);

  return res;
};

export const getPDFAprovacoes = async (id) => {
  const res = await api.get(`/api/Proposal/PDF/${id}`, { responseType: 'blob' }).then((response) => response);
  return res;
};

export const getCSVProposta = async (id) => {
  const res = await api.get(`/api/Export/CSV/${id}`, { responseType: 'blob' }).then((response) => response);
  return res;
};

export const updateValidity = async (fields) => {
  const res = await api.post(`/api/Contract/UpdateValidity/${fields.proposalId}`).then((response) => response.data);

  return res;
};

export const updateValidityClientAccess = async (token) => {
  const res = await apiClient
    .post('/api/Contract/ClientAccess/UpdateValidity', {}, { headers: { 'X-Client-Token': token } })
    .then((response) => response.data);

  return res;
};

export const saveEmail = async (emailFields) => {
  const res = await api.post(`/api/Proposal/Email/${emailFields.id}`, emailFields).then((response) => response.data);
  return res;
};

export const getConstructionsFunnel = async (params) => {
  const res = await api.get('/api/ConstructionFunnel', { params }).then((response) => response);
  return res;
};

export const getConstructionsFunnelProducts = async (id) => {
  const res = await api.get(`/api/ConstructionFunnel/Products/${id}`).then((response) => response);
  return res;
};

export const getProductsGroups = async () => {
  const res = await api.get('api/ConstructionFunnel/ProductsGroups').then((response) => response);
  return res;
};

export const listAlcadaTraco = async (sellerSchemeId) => {
  const res = await api
    .get('/api/HierarchyTrait/', { params: { take: 0, skip: 0, approvalSchemeId: sellerSchemeId } })
    .then((response) => response?.data || response);

  return res;
};

export const listAlcadaBomba = async (sellerSchemeId) => {
  const res = await api
    .get('/api/HierarchyBomb/', { params: { take: 0, skip: 0, approvalSchemeId: sellerSchemeId } })
    .then((response) => response?.data || response);

  return res;
};

export const getAllPlayers = async () => {
  const res = await api
    .get('/api/Player/', { params: { take: 0 } })
    .then((response) => response?.data || response);

  return res;
};

export const getAllLossCauses = async () => {
  const res = await api
    .get('/api/LossCause', { params: { take: 0 } })
    .then((response) => response?.data || response);

  return res;
};

export const getCustomer = async (code, params = {}) => {
  const res = await api
    .get(`/api/Customer/${code}`, { params })
    .then((response) => response?.data || response);

  return res;
};

export const listReceivers = async (document) => {
  const res = await api
    .get(`/api/Customer/Receivers/${document}`)
    .then((response) => response?.data || response);

  return res;
};
